import cn from 'classnames';
import { Ref } from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import {
  Appearance,
  AppearanceType,
  Background,
  BackgroundType,
  Design,
  DesignType,
  Size,
  SizeType
} from '../designConstants';
import { IconButton } from '../IconButton/IconButton';

interface DownloadToggleProps {
  appearance?: AppearanceType;
  design?: DesignType;
  background?: BackgroundType;
  size?: SizeType;
  disabled?: boolean;
  className?: string;
  onToggleClick: () => void;
  isOpen: boolean;
  buttonRef?: Ref<HTMLButtonElement>;
}

export const DownloadToggle = ({
  appearance = Appearance.FILLED,
  design = Design.BRAND,
  background = Background.LIGHT,
  size = Size.LG,
  disabled,
  className,
  onToggleClick,
  isOpen,
  buttonRef
}: DownloadToggleProps) => (
  <IconButton
    ref={buttonRef}
    appearance={appearance}
    design={design}
    background={background}
    size={size}
    disabled={disabled}
    className={cn('download-toggle', className)}
    onClick={onToggleClick}
    aria-expanded={isOpen}
  >
    <MdOutlineFileDownload />
  </IconButton>
);
